// Schema definition for reusable batch component state

export const batchStateSchema = {
    isLoading: {
        type: 'boolean',
        default: false,
        description: 'Loading state for batch operations.'
    },
    batches: {
        type: 'array',
        default: [],
        description: 'List of user batches.',
        items: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                name: { type: 'string' },
                description: { type: 'string'},
                createdAt: { type: 'string'},
                updatedAt: { type: 'string'},
                status_id: { type: 'number'},
                isStowing: { type: 'boolean', default: false},
                isListing: { type: 'boolean', default: false},
                isExporting: { type: 'boolean', default: false},
                isRemoving: { type: 'boolean', default: false},
                isUpdating: { type: 'boolean', default: false},
                // Batch statistics
                batch_item_item_count: { type: ['number', 'null'], default: null },
                batch_item_lot_count: { type: ['number', 'null'], default: null },
                total_value: { type: ['number', 'null'], default: null },
                stats: {
                    type: ['object', 'null'],
                    default: null,
                    properties: {
                        total_items: { type: 'number', default: 0 },
                        total_lots: { type: 'number', default: 0 },
                        total_value: { type: 'number', default: 0 },
                        new_items: { type: 'number', default: 0 },
                        stowed_items: { type: 'number', default: 0 },
                        listed_items: { type: 'number', default: 0 }
                    }
                },
                batch_items: {
                    type: 'array',
                    default: [],
                    items: {
                        type: 'object',
                        properties: {
                            id: { type: ['number', 'string'] }, 
                            batch_id: { type: ['number', 'string'] },
                            lot_id: { type: ['number', 'string'] },
                            color_id: { type: ['number', 'string'] },
                            color_name: { type: ['string', 'null'], default: null },
                            item_number: { type: ['string', 'null'], default: null },
                            item_name: { type: ['string', 'null'], default: null },
                            item_type: { type: ['string', 'null'], default: null },
                            qty: { type: 'number' },
                            condition: { type: 'string', enum: ['N', 'U']},
                            price: { type: 'number'},
                            user_inventory_item_id: { type: ['number', 'null'], default: null },
                            user_inventory_item_quantity: { type: ['number', 'null'], default: null },
                            user_inventory_item_location_name: { type: ['string', 'null'], default: null },
                            is_stowed: { type: 'boolean', default: false},
                            // Client-only pending flags for in-flight actions
                            is_stowed_pending: { type: 'boolean', default: false },
                            is_listed: { type: 'boolean', default: false},
                            is_listed_pending: { type: 'boolean', default: false },
                            createdAt: { type: ['string', 'null'], default: null },
                            updatedAt: { type: ['string', 'null'], default: null },
                            stowedAt: { type: ['string', 'null'], default: null },
                        }
                    }
                }
            }
        }
    }
}; 
